export class ContactAdjuster {
  public firstName: string;
  public lastName: string;
  public email: string;
  public phone: string;
  public comment: string;
}
